import React from 'react';
import { portal, Portal } from '../../../../../../Configs/general';

import PaymentCardGDC from './PaymentCard.GDC';

const PaymentCard = props => {
  switch (portal) {
    case Portal.Gascaribe:
    case Portal.Gasguajira:
    case Portal.Efigas:
      return <PaymentCardGDC {...props} />;
    default:
      return <></>;
  }
};

export default PaymentCard;
